// This logger encapsulates the vue-logger +  app-insights tracking calls and provides a uniform interface for logging functionality
// This is regsited in main.js as a Vue plugin.
//
//  import Logger from "./_services/logging";
//  Vue.use(Logger);

// Can be consumed as this.$logger.<functionName>(args) in any component and as Vue.$logger.<functionName>(args)
// in external functions where vue instance is not avalable
// Registering in main.js

import "./vue-logger.service";
import { AppInsightsService } from "./app-insights.service";

// AppInsightsService.init();

function parseMessage(args) {
  let message = "";
  for (var i = 0, j = args.length; i < j; i++) {
    if (message != "") {
      message += " ";
    }

    if (typeof args[i] === "object" && args[i] !== null) {
      try {
        message += JSON.stringify(args[i]);
      } catch {
        message += args[i];
      }
    } else {
      message += args[i];
    }
  }

  return message;
}

export default {
  // eslint-disable-next-line no-unused-vars
  install(Vue, options) {
    Vue.prototype.$logger = {
      debug() {
        let message = parseMessage(arguments);
        Vue.$log.debug(arguments);
        AppInsightsService.trackInfoEvent(message);
      },

      info() {
        let message = parseMessage(arguments);
        Vue.$log.info(arguments);
        AppInsightsService.trackInfoEvent(message);
      },

      warn() {
        let message = parseMessage(arguments);
        Vue.$log.warn(arguments);
        AppInsightsService.trackWarningEvent(message);
      },

      error() {
        let message = parseMessage(arguments);
        Vue.$log.error(arguments);
        AppInsightsService.trackErrorEvent(message);
      },

      fatal() {
        let message = parseMessage(arguments);
        Vue.$log.fatal(arguments);
        AppInsightsService.trackErrorEvent(message);
      },

      trackEventShortcutKey(name, properties) {
        let message = {};
        message.name = name;
        message.properties = properties;
        message.name = `Shortcut Key: ${name}`;

        Vue.$log.info(arguments);
        AppInsightsService.trackInfoEvent(message);
      },

      trackEventGridFilter(properties) {
        let message = {};
        // message.name = name;
        message.properties = properties;
        message.name = `Grid Filter`;

        Vue.$log.info(arguments);
        AppInsightsService.trackInfoEvent(message);
      },

      trackEventGridSearch(properties) {
        let message = {};
        // message.name = name;
        message.properties = properties;
        message.name = `Grid Search`;

        Vue.$log.info(arguments);
        AppInsightsService.trackInfoEvent(message);
      },

      trackEventOpenPopup(name, properties) {
        let message = {};
        message.name = name;
        message.properties = properties;
        message.name = `Popup: ${name}`;

        Vue.$log.info(arguments);
        AppInsightsService.trackInfoEvent(message);
      },

      trackEventOpenScreen(name, properties) {
        let message = {};
        message.name = name;
        message.properties = properties;
        message.name = `Screen: ${name}`;

        Vue.$log.info(arguments);
        AppInsightsService.trackInfoEvent(message);
      },

      trackEventButtonClick(name, properties) {
        let message = {};
        message.name = name;
        message.properties = properties || {};
        message.name = `Button Click: ${name}`;

        Vue.$log.info(arguments);
        AppInsightsService.trackInfoEvent(message);
      },

      trackEventButtonClickBack() {
        this.trackEventButtonClick("Back", {});
      },

      trackEventButtonClickEdit() {
        this.trackEventButtonClick("Edit", {});
      },

      trackEventButtonClickCopy() {
        this.trackEventButtonClick("Copy", {});
      },

      trackEventButtonClickDelete() {
        this.trackEventButtonClick("Delete", {});
      },

      trackEventButtonClickAddNew() {
        this.trackEventButtonClick("Add New", {});
      },

      trackEventButtonClickSave() {
        this.trackEventButtonClick("Save", {});
      },
    };
  },
};
